import { storageKey } from '@/utils/conf';
import { get } from 'lodash-es';
import { defineStore } from "pinia";
import { localStore, sessionStore } from "poppy-util";
import { apiAppAppInfo } from "@/services/app";


export const useStoreApp = defineStore("app", {
    state: () => ({
        user: {},
        years: [],
        provinces: [],
        specials: [],
        laws: [],
        policies: [],
        special: {},
        arrange: null,
        law: {},
        policy: {},
        unreadNum: 0,
        isXingce: 'Y',
        isGongan: 'Y',
        isGonganQuestion: 'Y',
    }),

    getters: {},
    actions: {
        async Init() {
            let token: any = localStore(storageKey.USER_TOKEN);
            let user: any = localStore(storageKey.USER_INFO);
            if (!token || !user) {
                return Promise.reject()
            }
            this.user = user;
            return Promise.resolve();
        },
        async FetchInfo() {
            apiAppAppInfo({}).then(({ data, success }) => {
                if (!success) {
                    localStore(storageKey.USER_TOKEN, null);
                    localStore(storageKey.USER_INFO, null);
                    return;
                }
                this.user = get(data, 'user');
                this.arrange = get(data, 'arrange');
                this.years = get(data, 'years');
                this.provinces = get(data, 'provinces');
                this.special = get(data, 'special');
                this.law = get(data, 'law');
                this.policy = get(data, 'policy');
                this.specials = get(data, 'specials');
                this.laws = get(data, 'laws');
                this.policies = get(data, 'policies');
                this.unreadNum = get(data, 'unread_num');
                this.isXingce = get(data, 'is_xingce');
                this.isGongan = get(data, 'is_gongan');
                this.isGonganQuestion = get(data, 'is_gongan_question');
            })
        },

        /**
         * 这里不触发动作, 动作的触发在 composables 中监听并执行
         * @param data
         * @constructor
         */
        Login(data: any) {
            localStore(storageKey.USER_INFO, data);
            localStore(storageKey.USER_TOKEN, get(data, 'token'));
            return this.FetchInfo();
        },

        /**
         * 操作登出/ 接口401
         * @constructor
         */
        Logout() {
            localStore(storageKey.USER_TOKEN, null);
            sessionStore(storageKey.USER_INFO, null);
            this.user = {};
            return Promise.resolve()
        },
    }
});

// export const storeUser = useStoreUser();